import { useCookiesContext } from "../../../../../contexts/CookiesContext";
import { statusLabels, positionLabels } from "@revbox/localization";
import { getPubAbbr } from "@revbox/helpers-fe";
import { TaxonomyModule } from "../../../../../modules/taxonomy";

export function ClusterPositionRenderer({ value }) {
    const { getLanguageAbbr } = useCookiesContext()
    if (!value) {
        return null;
    }
    const languageAbbr = getLanguageAbbr()
    const [currentPosRaw, , bids_amountRaw, , campaign_activeRaw, , , statusRaw] = value.split("@");
    const bids_amount = Number(bids_amountRaw);
    let currentPos = Number(currentPosRaw);
    let campaign_active = campaign_activeRaw;
    let status = statusRaw.split("#")[0];
    const notShownLabel = positionLabels[languageAbbr]["not_shown"];

    if (status === statusLabels[languageAbbr]["Pending"]) {
        return (
            <div className="align-items-center text-secondary">
                <small>{notShownLabel}</small>
            </div>
        );
    }

    if (campaign_active === "false") {
        return (
            <div className="align-items-center text-secondary">
                <small>{notShownLabel}</small>
            </div>
        );
    }

    if (currentPos <= bids_amount && currentPos > 0) {
        if (currentPos === 1) {
            return (
                <div className="align-items-center">
                    <span className="text-success fw-bold">#{currentPos}</span>
                </div>
            );
        } else {
            return (
                <div className="align-items-center">
                    <span className="">#{currentPos}</span>
                </div>
            );
        }
    }

    if (currentPos > bids_amount || currentPos === 0) {
        currentPos = notShownLabel;
    }

    if (currentPos !== notShownLabel) {
        currentPos = "#" + currentPos;
    }

    return (
        <div className="align-items-center">
            {
                currentPos === "Not shown" ? 
                (
                    <small className="">{currentPos}</small>
                ) : (
                    <small className="">{currentPos}</small>
                )
            }
        </div>
    );
}

export function PositionColumnHeaderTooltipRenderer() {
    const publisherIdByAbbr = getPubAbbr();
    const taxonomy = TaxonomyModule(publisherIdByAbbr);

    return taxonomy.tooltips.ppc_cluster_column_headers.position;
}

export function ClusterPositionCellTooltipRenderer({ value }) {
    const publisherIdByAbbr = getPubAbbr();
    const taxonomy = TaxonomyModule(publisherIdByAbbr);

    if (!value) {
        return null;
    }

    const [currentPosRaw, , bids_amountRaw] = value.split("@");
    const bids_amount = Number(bids_amountRaw);
    let currentPos = Number(currentPosRaw);

    if (bids_amount >= currentPos && currentPos > 0) {
        return taxonomy.tooltips.ppc_cluster_column_inlines.position.is_shown
            .replace('{position}', String(currentPos));
    }

    return taxonomy.tooltips.ppc_cluster_column_inlines.position.is_not_shown;
}